import { MutationTree } from "vuex";
import { BundleCourseState } from "./types";

export const mutations: MutationTree<BundleCourseState> = {};
